import { Button, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import Iconfont from 'components/Iconfont'
import ModalLink from 'components/ModalLink'
import { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useIsActivated, useL2AccountId } from 'store/account/hooks'
import { updateOpenRenderFlag } from 'store/app/actions'
import { useCurrentNetwork, useFaucetQueueLen, useModal } from 'store/app/hooks'
import { getDepositsEstimateMinutes } from 'store/deposit/hook'
import { ContentWrap, Flex } from 'styles'
import { bn } from 'utils/number'
import { updateModal } from '../../store/app/actions/modalActions'
import { useAtom } from 'jotai'
import { latestDepositExplorerUrlAtom } from './atoms'
import { COMMUNITY_LINKS } from '../../constants/community'
import { OpenMyAccountStep } from 'components/OpenMyAccountStep'
import { ReactComponent as IconView } from './view.svg'

const WaitText = styled(Flex)`
  width: 265px;
  flex-direction: column;
  justify-content: flex-start;
`
const WaitWrap = styled(Flex)`
  flex-direction: column;
  align-items: center;
`
const WaitContent = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  align-items: center;
`
const WaitLot = styled(Flex)`
  padding: 32px 0;
  .line-scale-pulse-out > div {
    background-color: rgba(199, 255, 92, 1);
  }
`
const WaitTextItem = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(149, 164, 173, 1);
  text-align: center;
  padding: 4px 0;

  &.title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
  }
`
const ViewAndCloseWrap = styled(Flex)`
  gap: 8px;
  align-items: center;
  padding: 24px 0;
`
const ViewWrap = styled(Button)`
  align-items: center;
  height: 36px;
  padding: 0 20px;
  gap: 8px;
  font-weight: 400;
  white-space: nowrap;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(42, 49, 57, 1);
  border-radius: 16px;

  &:hover {
    cursor: pointer;
    color: rgba(160, 238, 9, 1);
    background: rgba(57, 65, 73, 1);
  }
`
const CloseWrap = styled(Flex)`
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  border-radius: 15px;
  color: rgba(199, 255, 92, 1);
`

export const WaitingForConfirmationModal = memo(() => {
  const dispatch = useDispatch()
  // const openMyAccountModal = useModal('guide')
  const isActivated = useIsActivated()
  const waitingForConfirmationModal = useModal('depositing')
  const [latestDepositExplorerUrl, updateLatestDepositExplorerUrl] = useAtom(
    latestDepositExplorerUrlAtom,
  )
  const accountId = useL2AccountId()
  const [second, setSecond] = useState(30)
  const queue = useFaucetQueueLen()
  // const currentNetwork = useCurrentNetwork()

  console.log(latestDepositExplorerUrl)
  // clear latestDepositExplorerUrl when unmount
  useEffect(() => {
    return () => {
      updateLatestDepositExplorerUrl('')
    }
  }, [updateLatestDepositExplorerUrl])

  useEffect(() => {
    if (accountId) {
      dispatch(updateModal({ modal: 'depositing', open: false }))
      dispatch(updateOpenRenderFlag({ flag: 0 }))
    }
  }, [dispatch, accountId])
  useEffect(() => {
    // if (openMyAccountModal) {
    //   return
    // }
    if (!waitingForConfirmationModal) {
      setSecond(30)
      return
    }
    if (second <= 0) {
      dispatch(updateModal({ modal: 'depositing', open: false }))
      setSecond(30)
    }
    setTimeout(() => {
      setSecond(second - 1)
    }, 1000)
  }, [
    dispatch,
    setSecond,
    second,
    // openMyAccountModal,
    waitingForConfirmationModal,
  ])

  return (
    <ModalLink
      width="435px"
      isIn={waitingForConfirmationModal}
      header={
        latestDepositExplorerUrl
          ? 'Waiting for confirmation'
          : 'Faucet Processing...'
      }
      onClose={() => {
        dispatch(updateModal({ modal: 'depositing', open: false }))
        setSecond(5)
      }}
    >
      <ContentWrap>
        {!isActivated && <OpenMyAccountStep step={0} />}
        <WaitWrap>
          <WaitContent>
            <WaitLot>
              <div className="line-scale-pulse-out">
                <div />
                <div />
                <div />
                <div />
                <div />
              </div>
            </WaitLot>
            <WaitText>
              <WaitTextItem className={'title'}>
                Transactions have been initiated.
              </WaitTextItem>
              <WaitTextItem>
                {latestDepositExplorerUrl ? (
                  <>
                    {/* {getDepositsEstimateMinutes(currentNetwork.layerOneChainId)}{' '} */}
                    Waiting for confirmation.
                    <br />
                    Please check your wallet balance later.
                  </>
                ) : (
                  <>
                    {bn(queue).add(1).toString()} users are ahead of you in the
                    queue. Your request will be processed in{' '}
                    {Math.ceil((queue + 1) * 0.03).toFixed(0)} minutes by
                    estimation.
                    <br />
                    <Stack
                      component="a"
                      href={COMMUNITY_LINKS.DISCORD}
                      target="_black"
                      sx={{
                        marginTop: 1,
                        color: '#FFF',
                      }}
                      flexDirection="row"
                    >
                      <Iconfont name="icon-Discord" size={16} />
                      <span style={{ marginLeft: 4 }}>
                        Get support in the ZKEX Discord channel
                      </span>
                    </Stack>
                  </>
                )}
              </WaitTextItem>
            </WaitText>
          </WaitContent>
          <ViewAndCloseWrap>
            {latestDepositExplorerUrl ? (
              <ViewWrap
                onClick={() => {
                  window.open(latestDepositExplorerUrl, '_blank')
                }}
              >
                <IconView />
                View on explorer
              </ViewWrap>
            ) : null}

            <CloseWrap>closing in {second}s</CloseWrap>
          </ViewAndCloseWrap>
        </WaitWrap>
      </ContentWrap>
    </ModalLink>
  )
})
